import React, { useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@activecollab/components";
import classnames from "classnames";
import PropTypes from "prop-types";

export const ProjectObjectError = ({ type, className }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRedirect = useCallback(() => {
    navigate(`/projects`);
  }, [navigate]);

  return (
    <div className={classnames("project_object_error", className)}>
      <div className="project_object_error_inner">
        <h1>
          <Trans>This {type.toLowerCase()} is not found</Trans>
        </h1>
        <div className="empty_page">
          <div className="empty_page_image" />
          <div className="empty_page_content">{t("Go back to projects page for a fresh start.")}</div>
        </div>
        <div className="tw-text-center">
          <Button
            type="button"
            variant="primary"
            onClick={handleRedirect}
          >
            {t("Take me to projects")}
          </Button>
        </div>
      </div>
    </div>
  );
};

ProjectObjectError.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};

ProjectObjectError.defaultProps = {
  type: "Task",
};
